<template>
    <div class="ProgramServiceLog" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <div class="row" style="margin-top:5px;">
                <div class="col">
                    <h2>Program Family Service Log <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'download']" v-on:click="DownloadData()" class="pointer" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
                </div>
            </div>

            <form class="table-filters client-list" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Program:</label>
                            <select v-model="Filters.SubProgramID" class="form-control">
                                <option v-for="subprogram in ProgramList" :value="subprogram.value">{{ subprogram.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Family:</label>
                            <v-select :options="FamiliesList" label="text" :reduce="option => option.value" v-model="Filters.FamilyID">
                                <template #search="{attributes, events}">
                                    <input class="vs__search"
                                           v-bind="attributes"
                                           v-on="events" />
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>From:</label>
                            <flat-pickr v-model="Filters.StartDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>To:</label>
                            <flat-pickr v-model="Filters.EndDateTime" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Entries:</label>
                            <input type="text" v-model="search" class="form-control" aria-label="Search" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4"></div>

                </div>
            </form>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="servicelogentriestable"
                      track-by="Id">
                <template slot="EntryDateTime" scope="props">
                    <div class="EntryDateTime">
                        <span>{{ formatEffectiveDateTime(props.rowData.EffectiveDateTime) }}</span>
                    </div>
                </template>
                <template slot="EntryNotes" scope="props">
                    <div class="EntryNotes">
                        <span>{{ props.rowData.Note }}</span> <span v-if="props.rowData.DocumentID"><font-awesome-icon :icon="['fa', 'paperclip']" v-on:click="ViewDocument(props.rowData.DocumentPDFFileID, props.rowData.DocumentLabel, props.rowData.DocumentFileName)" class="pointer" /></span>
                    </div>
                </template>
            </vuetable>
        </div>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
    library.add(faPaperclip);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    import DocumentViewer from "../../Core/RecordComponents/DocumentViewer.vue";

    export default {
        mixins: [TableScrollerSupport],
        created() {
        },
        props: [
            
        ],
        data: function () {
            return {
                LoadingRecords: false,
                NumberOfRecords: 0,
                search: "",
                Filters: {
                    StartDateTime: "",
                    EndDateTime: "",
                    FamilyID: "",
                    SubProgramID: ""
                },
                AuthorList: [],
                Fields: [
                    {
                        name: '__slot:EntryDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                        dataClass: 'cell-no-wrap'
                    },
                    {
                        name: 'EffectiveDateTime',
                        title: "Date/Time",
                        sortField: 'EffectiveDateTime',
                        dataClass: 'cell-no-wrap',
                        callback: 'formatDate|MM/DD/YY',
                        visible: false,
                    },
                    {
                        name: 'ChartName',
                        title: 'Family',
                        sortField: 'ChartName',
                    },
                    {
                        name: 'Category',
                        title: 'Category',
                        sortField: 'Category',
                    },
                    {
                        name: 'EmployeeAuthorName',
                        title: 'Author',
                        sortField: 'EmployeeAuthorName',
                    },
                    {
                        name: '__slot:EntryNotes',
                        title: "Notes",
                        sortField: 'Note',
                        width: "40%"
                    },
                    {
                        name: 'Note',
                        title: "Notes",
                        sortField: 'Note',
                        visible: false
                    }
                ],
                EntryData: [],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetEntries(true);
            },
            GetEntries(displayLoad = false) {
                this.LoadingRecords = true;
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FamilyServiceLog/GetEntries", this.Filters, this.GetEntriesSuccess, () => { }, displayLoad);
            },
            GetEntriesSuccess(response) {
                this.LoadingRecords = false;
                this.EntryData = response.data.data;
                this.$refs.datatable.refresh();
            },
            DownloadData(displayLoad = false) {
                this.$MasterAPI.ExecuteFileRequest("Foster/FamilyServiceLog/DownloadEntries", this.Filters);
            },
            formatEffectiveDateTime(value) {
                if (value.substring(11) == "00:00:00") {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY");
                } else {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YY hh:mm A");
                }
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.EntryData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData;
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfRecords = visibleData.length;
                return visibleData;
            },

            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr,
            DocumentViewer,
            vSelect,
            TableScrollerSupport
        },
        computed: {
            FamiliesList: function () {
                let output = [];
                this.$store.state.Families.FamilyEnrollmentsList.forEach(function (i) {
                    output.push({ text: i.Family.Name, value: i.Family.Id });
                });
                output = output.sort((a, b) => (a.text > b.text) ? 1 : -1);
                return output;
            },
            ProgramList: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        mounted() {
            this.Filters.StartDateTime = moment().add(-30, "days").format("YYYY-MM-DD");
            this.Filters.EndDateTime = moment().format("YYYY-MM-DD");
            //this.GetEntries(false);
            this.$refs.datatable.refresh();
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>